import { mergeStyleSets } from '@fluentui/react';

export const useStyles = () => {
  return mergeStyleSets({
    flowstepContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      padding: '16px',
    }
  })
}